import React, { useState } from 'react';
import { SessionsPage } from './SessionsPage';
import { ConversationsPage } from './ConversationsPage';
import { RequestsPage } from './RequestsPage';

// One place to browse past dialogs. Two data models under tabs:
//  - Sessions: platform sessions (/api/agents/connect + text-chat/voice) — what
//    live-video-chat and Twilio use. Has lifecycle, metrics, caller info.
//  - Conversations: Mastra Memory threads from the standard /api/std drop-in.
type Tab = 'sessions' | 'conversations' | 'requests';

export function DialogsPage() {
  const [tab, setTab] = useState<Tab>('sessions');

  return (
    <div style={s.container}>
      <div style={s.top}>
        <h2 style={s.heading}>Dialogs</h2>
        <div style={s.tabs}>
          <button
            style={{ ...s.tab, ...(tab === 'sessions' ? s.tabActive : {}) }}
            onClick={() => setTab('sessions')}
          >
            Sessions
          </button>
          <button
            style={{ ...s.tab, ...(tab === 'conversations' ? s.tabActive : {}) }}
            onClick={() => setTab('conversations')}
          >
            Conversations
          </button>
          <button
            style={{ ...s.tab, ...(tab === 'requests' ? s.tabActive : {}) }}
            onClick={() => setTab('requests')}
          >
            Requests
          </button>
        </div>
      </div>
      <div style={s.body}>
        {tab === 'sessions' && <SessionsPage embedded />}
        {tab === 'conversations' && <ConversationsPage embedded />}
        {tab === 'requests' && <RequestsPage embedded />}
      </div>
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  container: { display: 'flex', flexDirection: 'column', height: '100%', flex: 1, minHeight: 0 },
  top: { padding: '20px 20px 0' },
  heading: { margin: '0 0 12px', fontSize: 18, color: '#1a1a1a' },
  tabs: { display: 'flex', gap: 4, borderBottom: '1px solid #e5e7eb' },
  tab: {
    padding: '8px 16px', border: 'none', background: 'none', cursor: 'pointer',
    fontSize: 13, color: '#666', borderBottom: '2px solid transparent', marginBottom: -1,
  },
  tabActive: { color: '#4f46e5', fontWeight: 600, borderBottomColor: '#4f46e5' },
  body: { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' },
};
